import { useEffect, useState } from 'react';

type UseToast = {
  id: string;
  clearId: (id: string) => void;
  delay?: number;
  toastVisible?: boolean;
};

export const useToast = ({ delay, clearId, id, toastVisible = true }: UseToast) => {
  const [isVisible, setIsVisible] = useState<boolean>(toastVisible);

  const clearToast = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (delay) {
      timeout = setTimeout(clearToast, delay);
    }

    return () => {
      timeout && clearTimeout(timeout);
    };
  }, [delay]);

  const onAnimationEnd = () => {
    !isVisible && clearId(id);
  };

  return {
    clearToast,
    isVisible,
    onAnimationEnd,
  };
};
